"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryICNSNames = exports.ObservableQueryICNSNamesInner = void 0;
const contract_query_1 = require("../cosmwasm/contract-query");
const mobx_1 = require("mobx");
const chain_query_1 = require("../chain-query");
class ObservableQueryICNSNamesInner extends contract_query_1.ObservableCosmwasmContractChainQuery {
    constructor(kvStore, chainId, chainGetter, contractAddress, address) {
        super(kvStore, chainId, chainGetter, contractAddress, {
            icns_names: { address: address },
        });
        this.contractAddress = contractAddress;
        this.address = address;
    }
    get primaryName() {
        if (!this.response || !this.response.data) {
            return "";
        }
        return this.response.data.primary_name;
    }
    get names() {
        if (!this.response || !this.response.data) {
            return [];
        }
        return this.response.data.names;
    }
}
__decorate([
    mobx_1.computed
], ObservableQueryICNSNamesInner.prototype, "primaryName", null);
__decorate([
    mobx_1.computed
], ObservableQueryICNSNamesInner.prototype, "names", null);
exports.ObservableQueryICNSNamesInner = ObservableQueryICNSNamesInner;
class ObservableQueryICNSNames extends chain_query_1.ObservableChainQueryMap {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, (key) => {
            const split = key.split("/");
            return new ObservableQueryICNSNamesInner(this.kvStore, this.chainId, this.chainGetter, split[0], split[1]);
        });
        this.kvStore = kvStore;
        this.chainId = chainId;
        this.chainGetter = chainGetter;
    }
    getQueryContract(contractAddress, address) {
        return this.get(`${contractAddress}/${address}`);
    }
}
exports.ObservableQueryICNSNames = ObservableQueryICNSNames;
//# sourceMappingURL=names.js.map